<template>
  <v-dialog max-width="500px" v-model="dialog">
    <attend-details :dates="filterBy" :empAttend="empAttend" v-if="empAttend" />
  </v-dialog>
</template>

<script>
import AttendDetails from './AttendDetails'
export default {
  props: ['filterBy'],
  components: {
    AttendDetails
  },
  created() {
    this.setEmp()
  },
  data() {
    return {
      dialog: true,
      empAttend: false
    }
  },
  computed: {
    empId() {
      return this.$route.params.id
    },
    attends() {
      return this.$store.getters.monthlyAttends
    }
  },
  methods: {
    setEmp() {
      if (!this.attends) return
      this.dialog = true
      this.empAttend = this.attends.find(emp => emp._id === this.empId)
    },
    onClose() {
      this.dialog = false
      this.$router.push('./')
    }
  },
  watch: {
    dialog(val) {
      val || this.onClose()
    },
    '$route.params.id': function () {
      this.setEmp()
    },
    attends() {
      this.setEmp()

    }
  },
}
</script>

<style></style>